import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';
import { Colors } from '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import 'core-js/modules/es.array.concat.js';
import '@cognite/cogs-utils';
import '@mui/joy';
import '@cognite/cogs-icons';
import { Tooltip } from '../tooltip/tooltip.js';

var getPromoChipColors = function getPromoChipColors(color, inverted) {
  if (inverted) {
    return {
      backgroundColor: Colors["surface--medium--inverted"],
      color: Colors["decorative--" + color + "--100"]
    };
  }
  return {
    backgroundColor: Colors["decorative--" + color + "--50"],
    color: Colors["decorative--" + color + "--800"]
  };
};
/**
 * Promo chips are used to signify a stage from the feature's service lifecycle.
 * `inverted`, `type`, `size` will be deprecated in the next release.
 */
var PromoChip = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    color = _a.color,
    _a$tooltip = _a.tooltip,
    tooltip = _a$tooltip === undefined ? true : _a$tooltip,
    _a$dense = _a.dense,
    dense = _a$dense === undefined ? false : _a$dense,
    tooltipProps = _a.tooltipProps,
    children = _a.children,
    _a$inverted = _a.inverted,
    inverted = _a$inverted === undefined ? false : _a$inverted,
    otherProps = __rest(_a, ["className", "color", "tooltip", "dense", "tooltipProps", "children", "inverted"]);
  var innerRef = React.useRef(null);
  var _React$useState = React.useState(false),
    isOverflowing = _React$useState[0],
    setIsOverflowing = _React$useState[1];
  var showTooltip = tooltip === true && isOverflowing || typeof tooltip === 'string';
  React.useLayoutEffect(function () {
    if (innerRef.current) {
      setIsOverflowing(innerRef.current.scrollWidth > innerRef.current.clientWidth);
    }
  }, [children]);
  return jsx(Tooltip, Object.assign({}, tooltipProps, {
    disabled: !showTooltip,
    content: typeof tooltip === 'string' ? tooltip : children,
    children: jsx("span", Object.assign({
      ref: ref,
      className: classNames('cogs-v10', 'cogs-promochip', "cogs-promochip--" + (dense ? 'dense' : 'default'), className),
      "data-testid": "promo-chip"
    }, otherProps, {
      style: Object.assign(Object.assign({}, color ? getPromoChipColors(color, inverted) : {}), otherProps.style),
      children: jsx("span", {
        ref: innerRef,
        className: classNames('cogs-v10', 'cogs-promochip__text'),
        children: children
      })
    }))
  }));
});

export { PromoChip };
